export default "__VITE_ASSET__eY4LJfPV5j04kkbdM$9juA__";